/* ===========================================================
   まとめ買い：1着（1枚）ごとにカラー・サイズを選べるようにする
   ・2個以上のプランを選ぶと、その個数分の選択欄が表示されます
   ・カートには選んだ組み合わせごとに追加されます
   =========================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cfg = window.themeConfig || { routes: {} };

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function init(root) {
    if (root.dataset.bpInit) return;
    var json = $('[data-product-json]', root);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    if (!product.variants || product.variants.length < 2) return;
    root.dataset.bpInit = '1';
    var idInput = $('form.p-form input[name="id"]', root);
    var unit = root.dataset.bpUnit || '個';

    $$('.tier', root).forEach(function (tier) {
      var qty = parseInt(tier.dataset.qty, 10) || 1;
      if (qty < 2 || (tier.dataset.variantMatch || '').trim()) return;
      var u = (tier.dataset.name || '').indexOf('枚') > -1 ? '枚' : (tier.dataset.name || '').indexOf('着') > -1 ? '着' : unit;
      var box = document.createElement('div');
      box.className = 'tier__picks';
      var html = '<p class="tier__picks-label">' + esc(product.options.join('・')) + 'を選んでください</p>';
      for (var i = 0; i < qty; i++) {
        html += '<div class="tier__pick"><span class="tier__pick-no">' + (i + 1) + u + '目</span><select data-bp-select aria-label="' + (i + 1) + u + '目の' + esc(product.options.join('・')) + '">';
        product.variants.forEach(function (v) {
          html += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : '（売り切れ）') + '</option>';
        });
        html += '</select></div>';
      }
      box.innerHTML = html;
      tier.appendChild(box);
      tier.classList.add('has-picks');
      // セレクトを触ってもラジオの選択が外れないように
      box.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    function syncDefaults() {
      var cur = idInput ? idInput.value : product.variants[0].id;
      $$('[data-bp-select]', root).forEach(function (s) { if (!s.dataset.touched) s.value = cur; });
    }
    function update() {
      var checked = $('input[name="bundle-tier"]:checked', root);
      var tier = checked && checked.closest('.tier');
      var multi = !!(tier && tier.classList.contains('has-picks'));
      root.classList.toggle('bp-multi', multi);
      if (multi) syncDefaults();
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-bp-select]')) e.target.dataset.touched = '1';
      else update();
    });
    update();

    function selection() {
      var checked = $('input[name="bundle-tier"]:checked', root);
      var tier = checked && checked.closest('.tier');
      if (!tier || !tier.classList.contains('has-picks')) return null;
      var counts = {};
      $$('[data-bp-select]', tier).forEach(function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
      return { name: tier.dataset.name || '', items: Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id], properties: { '_まとめ買い': tier.dataset.name || '' } }; }) };
    }
    function add(e) {
      var sel = selection();
      if (!sel) return; // 1個のときは通常の処理
      e.preventDefault();
      e.stopImmediatePropagation();
      var btns = $$('[data-atc], [data-sticky-atc-btn]', root);
      btns.forEach(function (b) { b.disabled = true; });
      var err = $('[data-atc-error]', root); if (err) err.textContent = '';
      fetch((cfg.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: sel.items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'カートに追加できませんでした');
          var opener = document.querySelector('[data-drawer-open="CartDrawer"]');
          if (cfg.cartDrawer && opener) opener.click();
          else window.location.href = cfg.routes.cart || '/cart';
        })
        .catch(function (ex) { if (err) err.textContent = ex.message; })
        .finally(function () { btns.forEach(function (b) { b.disabled = false; }); });
    }
    // テーマ本体より先に処理する（capture）
    document.addEventListener('submit', function (e) { if (root.contains(e.target) && e.target.matches('form.p-form')) add(e); }, true);
    document.addEventListener('click', function (e) { var b = e.target.closest('[data-sticky-atc-btn]'); if (b && root.contains(b)) add(e); }, true);
  }

  function start() { $$('[data-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
